import React from "react";
import "../styles/footer.css";

const Footer = () => {
  return (
    <div id="footer">
      <p className="footer-header">contact-me-via:</p>
      <div className="footer-links">
        <a href="mailto:mertarinci96@gmail.com" className="footer-link">
          <i class="fa-solid fa-envelope"></i>
        </a>
        <a
          href="https://linkedin.com/in/mert-arinci-7536ab26a/"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-link"
        >
          <i class="fa-brands fa-linkedin-in"></i>
        </a>
        <a
          href="https://wa.me/0031616150171"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-link last-link"
        >
          <i class="fa-brands fa-whatsapp"></i>
        </a>
      </div>
      <div className="footer-pull-right">
        <a
          href="http://github.com/mertarinci"
          target="_blank"
          rel="noopener noreferrer"
          className="github-link"
        >
          <span>
            @mertarinci <i class="fa-brands fa-github"></i>
          </span>
        </a>
      </div>
    </div>
  );
};

export default Footer;
